import React, { Component } from "react";
import $ from "jquery";
import { Translate } from "react-redux-i18n";
import { connect } from "react-redux";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { compressImage } from "../../utils/Utils";
import ToggleSwitch from "../../utils/components/ToggleSwitch";
import "../../../styles/components/evs/modals/ActionFleet.scss";
import camera from "../../../styles/images/camera.svg";
import LoadingSpinner from "../../utils/components/LoadingSpinner"

class ActionFleet extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      validated: false,

      picture: null,
      name: "",
      shareFleet: false,
      shareEVData: false,
      acceptKMs: false,
      updateKMs: false,
      updateKMsFleet: false,
      acceptKMsFleet: false,
    };

    this.handlePictureChange = this.handlePictureChange.bind(this);
    this.handleToggleSwitch = this.handleToggleSwitch.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.selectedFleet)
      if (
        prevProps?.selectedFleet?._id !== this.props.selectedFleet._id ||
        prevProps?.selectedFleet?.sharedWithOPC !==
        this.props.selectedFleet.sharedWithOPC ||
        prevProps?.selectedFleet?.shareEVData !==
        this.props.selectedFleet.shareEVData ||
        prevProps?.selectedFleet?.listEvs?.acceptKMs !==
        this.props.selectedFleet.listEvs.acceptKMs ||
        prevProps?.selectedFleet?.listEvs?.updateKMs !==
        this.props.selectedFleet.listEvs.updateKMs ||
        prevProps?.selectedFleet?.acceptKMs !==
        this.props.selectedFleet.acceptKMs ||
        prevProps?.selectedFleet?.updateKMs !==
        this.props.selectedFleet.updateKMs ||
        (this.props.selectedFleet.imageContent !== "" &&
          this.state.picture === null)
      ) {
        this.safeSetState({
          picture: this.props.selectedFleet.imageContent + "?v=" + Date.now(),
          name: this.props.selectedFleet.name,
          shareFleet: this.props.selectedFleet.sharedWithOPC,
          shareEVData: this.props.selectedFleet.shareEVData,
          acceptKMs: this.props.selectedFleet.listEvs[0]?.acceptKMs,
          updateKMs: this.props.selectedFleet.listEvs[0]?.updateKMs,
          acceptKMsFleet: this.props.selectedFleet?.acceptKMs,
          updateKMsFleet: this.props.selectedFleet?.updateKMs,
        });
      }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handlePickPicture(e) {
    document.getElementById("file-picker").click();
  }

  handlePictureChange(e) {
    let file = e.target.files && e.target.files[0];

    compressImage(file).then((picture) => {
      this.safeSetState({ picture });
    });
  }

  handleOnSubmit(e) {
    e.preventDefault();
    const form = $(e.target)[0];
    this.safeSetState({ validated: true }, () => {
      if (form.checkValidity() !== false) {
        this.props.toggleLoadingActionCards(true)
        if (this.props.mode === "add")
          this.props.onSubmit(
            form.elements,
            this.state.picture,
            this.state.shareFleet,
            this.state.shareEVData,
            this.state.acceptKMsFleet,
            this.state.updateKMsFleet
          );
        else
          this.props.onSubmit(
            form.elements,
            this.props.selectedFleet._id,
            this.state.picture,
            this.state.shareFleet,
            this.state.shareEVData,
            this.state.acceptKMs,
            this.state.updateKMs,
            this.state.acceptKMsFleet,
            this.state.updateKMsFleet
          );
      }
    });
  }

  handleToggleSwitch(e) {
    this.safeSetState({
      [e.target.name]: e.target.checked,
    });
  }

  resetState() {
    this.safeSetState({
      name: "",
      validated: false,
      picture: null,
      shareFleet: false,
      shareEVData: false,
      acceptKMs: false,
      updateKMs: false,
      acceptKMsFleet: false,
      updateKMsFleet: false,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <Modal
        id="actionFleet"
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={this.resetState}
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <Translate value={`evs_${this.props.mode}Fleet`} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="picture-picker-container">
            <input
              id="file-picker"
              type="file"
              style={{ display: "none" }}
              onChange={this.handlePictureChange}
            />
            <button
              type="button"
              className="picture-picker"
              onClick={this.handlePickPicture}
            >
              <img id="picture" src={this.state.picture} alt="avatar" />
              <img src={camera} className="camera" alt="" />
            </button>
          </div>
          <Form
            id="action-fleet-form"
            noValidate
            validated={this.state.validated}
            onSubmit={this.handleOnSubmit}
          >
            <Form.Group className="form-field" controlId="fleetName">
              <Form.Label>
                <Translate value="editFleet_name" />
              </Form.Label>
              <Form.Control
                type="text"
                defaultValue={this.state.name}
                required
              />
              <Form.Control.Feedback type="invalid">
                <Translate value="editFleet_invalidName" />
              </Form.Control.Feedback>
            </Form.Group>
          </Form>

          {this.props.userPackage?.mileageEntryEnabled &&
            this.props.mode === "edit" && (
              <div className="toggle-switch-container">
                <ToggleSwitch
                  name="acceptKMsFleet"
                  label={<Translate value="evs_acceptKMs" />}
                  checked={this.state.acceptKMsFleet}
                  onChange={this.handleToggleSwitch}
                />
              </div>
            )}

          {this.props.userPackage?.mileageEntryEnabled &&
            this.props.mode === "edit" &&
            this.state.acceptKMsFleet && (
              <div className="toggle-switch-container">
                <ToggleSwitch
                  name="updateKMsFleet"
                  label={<Translate value="evs_updateKMs" />}
                  checked={this.state.updateKMsFleet}
                  onChange={this.handleToggleSwitch}
                />
              </div>
            )}
          <hr></hr>
          <div className="toggle-switch-container">
            <ToggleSwitch
              name="shareFleet"
              label={<Translate value="backOffice_shareFleet_description" />}
              checked={this.state.shareFleet}
              onChange={this.handleToggleSwitch}
            />
          </div>
          {this.state.shareFleet && (
            <div className="toggle-switch-container">
              <ToggleSwitch
                name="shareEVData"
                label={<Translate value="backOffice_shareEVData_description" />}
                checked={this.state.shareEVData}
                onChange={this.handleToggleSwitch}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {this.props.loading === true ? <LoadingSpinner /> : <button type="submit" form="action-fleet-form">
            <Translate value={"addAddress_saveBtn"} />
          </button>}
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  userPackage: state.account.accountData.userPackage,
});

export default connect(mapStateToProps)(ActionFleet);
